import { Box } from "@mantine/core";
import { ReactNode } from "react";
import "./faq.css";

/**
 * L2KFAQContent - Wrapper component for FAQ answer content
 * 
 * Provides consistent styling and structure for FAQ answers.
 * Supports rich content including paragraphs, lists, links, etc.
 * 
 * @example
 * <L2KFAQContent>
 *   <p>This is the answer content.</p>
 *   <ul>
 *     <li>Item 1</li>
 *     <li>Item 2</li>
 *   </ul>
 * </L2KFAQContent>
 */
export interface L2KFAQContentProps {
  /** The content to display (can include JSX) */
  children: ReactNode;
  /** Additional CSS classes */
  className?: string;
}

export function L2KFAQContent({ children, className }: L2KFAQContentProps) {
  return (
    <Box className={`l2k-faq-content-wrapper ${className || ""}`}>
      {children}
    </Box>
  );
}

